<template>
<b-card>
    <validation-observer ref="observer" v-slot="{ passes }">
    <b-form @submit.prevent="passes(onFormSubmit)" novalidate>
        <b-form-row>
            <b-col md="3">
                <b-form-group label="Aan" label-for="addressed_to"><b-form-input id="addressed_to" v-model="form.addressed_to" /></b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Patiënte" label-for="patient_name"><b-form-input id="patient_name" v-model="form.patient_name" /></b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Geboren" label-for="patient_dob"><b-form-datepicker id="patient_dob" v-model="form.patient_dob" :locale="currentLang" :max="maxDate"></b-form-datepicker></b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Adres" label-for="address"><b-form-input id="address" v-model="form.address" /></b-form-group>
            </b-col>
        </b-form-row>

        <hr>
        <p class="small text-muted mb-2">Is op ... om ... bevallen van zoon/dochter na een zwangerschap duur van ... weken.</p>
        <b-form-row>
            <b-col md="2">
                <b-form-group label="Bevallen op" label-for="delivery_date"><b-form-input id="delivery_date" v-model="form.delivery_date" /></b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Om" label-for="delivery_time"><b-form-input id="delivery_time" v-model="form.delivery_time" /></b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Zoon/Dochter" label-for="child_gender"><b-form-input id="child_gender" v-model="form.child_gender" /></b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Zwangerschapsduur (weken)" label-for="gestation_weeks"><b-form-input id="gestation_weeks" v-model="form.gestation_weeks" /></b-form-group>
            </b-col>
        </b-form-row>

        <hr>
        <p class="small text-muted mb-2">Bij opname</p>
        <b-form-row>
            <b-col md="1"><b-form-group label="G" label-for="gravida"><b-form-input id="gravida" v-model="form.gravida" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="P" label-for="para"><b-form-input id="para" v-model="form.para" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="Ab" label-for="abortion"><b-form-input id="abortion" v-model="form.abortion" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="M" label-for="miscarriage"><b-form-input id="miscarriage" v-model="form.miscarriage" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="VDRL" label-for="vdrl"><b-form-input id="vdrl" v-model="form.vdrl" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="TPHA" label-for="tpha"><b-form-input id="tpha" v-model="form.tpha" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="1"><b-form-group label="Bldg/RH" label-for="blood_group_rh"><b-form-input id="blood_group_rh" v-model="form.blood_group_rh" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="HBsAg" label-for="hbsag"><b-form-input id="hbsag" v-model="form.hbsag" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="Hep C" label-for="hep_c"><b-form-input id="hep_c" v-model="form.hep_c" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="Hb (mmol/l)" label-for="hb"><b-form-input id="hb" v-model="form.hb" /></b-form-group></b-col>
            <b-col md="1"><b-form-group label="Hiv" label-for="hiv"><b-form-input id="hiv" v-model="form.hiv" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="2"><b-form-group label="Sikkelcel" label-for="sikkelcel"><b-form-input id="sikkelcel" v-model="form.sikkelcel" /></b-form-group></b-col>
            <b-col md="2"><b-form-group label="Type" label-for="sikkelcel_type"><b-form-input id="sikkelcel_type" v-model="form.sikkelcel_type" /></b-form-group></b-col>
            <b-col md="2"><b-form-group label="Malaria" label-for="malaria"><b-form-input id="malaria" v-model="form.malaria" /></b-form-group></b-col>
        </b-form-row>

        <hr>
        <b-form-row>
            <b-col md="4">
                <b-form-group label="Prenatale zorg door (Ciah's/de huisarts/elders)" label-for="prenatal_care_by"><b-form-input id="prenatal_care_by" v-model="form.prenatal_care_by" /></b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group label="Vanaf (wkn)" label-for="prenatal_care_from_weeks"><b-form-input id="prenatal_care_from_weeks" v-model="form.prenatal_care_from_weeks" /></b-form-group>
            </b-col>
        </b-form-row>

        <b-form-row>
            <b-col md="3">
                <b-form-group label="Bijzonderheden huidige zwangerschap" label-for="current_pregnancy_notes"><b-form-textarea id="current_pregnancy_notes" rows="3" v-model="form.current_pregnancy_notes" /></b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Bijzonderheden Obstetrische Anamnese" label-for="obstetric_history_notes"><b-form-textarea id="obstetric_history_notes" rows="3" v-model="form.obstetric_history_notes" /></b-form-group>
            </b-col>
        </b-form-row>

        <hr>
        <b-form-row>
            <b-col md="3"><b-form-group label="Aard van de partus" label-for="delivery_nature"><b-form-input id="delivery_nature" v-model="form.delivery_nature" /></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Duur uitdrijving" label-for="expulsion_duration"><b-form-input id="expulsion_duration" v-model="form.expulsion_duration" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="3"><b-form-group label="Placenta geboren" label-for="placenta_born"><b-form-input id="placenta_born" v-model="form.placenta_born" /></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Aspect" label-for="placenta_aspect"><b-form-input id="placenta_aspect" v-model="form.placenta_aspect" /></b-form-group></b-col>
        </b-form-row>
        <b-form-row>
            <b-col md="3"><b-form-group label="Bloedverlies" label-for="blood_loss"><b-form-input id="blood_loss" v-model="form.blood_loss" /></b-form-group></b-col>
            <b-col md="3"><b-form-group label="Perineum" label-for="perineum"><b-form-input id="perineum" v-model="form.perineum" /></b-form-group></b-col>
        </b-form-row>
        <b-col md="6" class="p-0">
            <b-form-group label="Bijzonderheden" label-for="delivery_notes"><b-form-textarea id="delivery_notes" rows="3" v-model="form.delivery_notes" /></b-form-group>
        </b-col>

        <hr>
        <p class="small text-muted mb-2">Bijzonderheden Kind</p>
        <b-form-row>
            <b-col md="2"><b-form-group label="Gewicht (gram)" label-for="child_weight"><b-form-input id="child_weight" v-model="form.child_weight" /></b-form-group></b-col>
            <b-col md="2"><b-form-group label="Lengte (cm)" label-for="child_length"><b-form-input id="child_length" v-model="form.child_length" /></b-form-group></b-col>
            <b-col md="2"><b-form-group label="Schedel omtrek (cm)" label-for="child_head_circumference"><b-form-input id="child_head_circumference" v-model="form.child_head_circumference" /></b-form-group></b-col>
        </b-form-row>
        <b-col md="6" class="p-0">
            <b-form-group label="Advies consult pediater ivm" label-for="pediatrician_advice"><b-form-textarea id="pediatrician_advice" rows="2" v-model="form.pediatrician_advice" /></b-form-group>
        </b-col>

        <hr>
        <b-col md="3" class="p-0">
            <b-form-group label="Verlosk" label-for="midwife"><b-form-input id="midwife" v-model="form.midwife" /></b-form-group>
        </b-col>

        <b-col md="3" class="p-0">
            <b-form-group
                label="Administrative date"
                label-for="administrative_datetime">
                    <b-form-datepicker id="administrative_datetime" placeholder="Set administrative date..." v-model="form.administrative_datetime" :locale="currentLang" :max="maxDate"></b-form-datepicker>
            </b-form-group>
        </b-col>

        <b-button class="mr-1" type="submit" variant="success"><i class="fa-regular fa-circle-dot"></i> Submit</b-button>
        <b-button v-if="isDirty || hasErrors" type="button" variant="danger" @click="reset"><i class="fa-solid fa-ban"></i> Reset</b-button>
    </b-form>
    </validation-observer>
</b-card>
</template>
<script>
import FormExtension from "@/core/components/FormExtension"

const DEFAULTS = {
    addressed_to: '',
    patient_name: '',
    patient_dob: null,
    address: '',
    delivery_date: '',
    delivery_time: '',
    child_gender: '',
    gestation_weeks: '',
    gravida: '',
    para: '',
    abortion: '',
    miscarriage: '',
    vdrl: '',
    tpha: '',
    blood_group_rh: '',
    hbsag: '',
    hep_c: '',
    hb: '',
    hiv: '',
    sikkelcel: '',
    sikkelcel_type: '',
    malaria: '',
    prenatal_care_by: '',
    prenatal_care_from_weeks: '',
    current_pregnancy_notes: '',
    obstetric_history_notes: '',
    delivery_nature: '',
    expulsion_duration: '',
    placenta_born: '',
    placenta_aspect: '',
    blood_loss: '',
    perineum: '',
    delivery_notes: '',
    child_weight: '',
    child_length: '',
    child_head_circumference: '',
    pediatrician_advice: '',
    midwife: '',
    administrative_datetime: null,
    consistency_token: null
}

export default FormExtension.extend({
    name: "ontslagbrief-form",
    data() {
        return {
            form: new Form({ ...DEFAULTS }),
            maxDate: new Date(),
        }
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        },
        refresh: {
            immediate: true,
            handler(val) {
                if(val) {
                   this.reset()
                }
            }
        }
    },
    methods: {
        async loadForPatient(patient) {
            this.newFormWithDefaults()
        },
        onFormSubmit() {
            this.callback(this.form.data()).then(() => {
                this.reset()
                this.notify("Ontslagbrief created", "Ontslagbrief was created successfully")
                this.$emit('created')
            })
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        newFormWithDefaults() {
            this.form = Form.create({ ...DEFAULTS })
        },
        reset() {
            this.newFormWithDefaults()

            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.hasErrors = false
                this.validated()
            })
        }
    }
})
</script>
